import React from 'react';

const b2cStyle = {
  backgroundColor: '#C879B2',
  width: 46,
  height: 30,
  display: 'inline-block',
  color: '#F5F7F9',
  borderRadius: 3,
  textAlign: 'center',
  fontSize: 12,
  fontWeight: 500,
  textTransform: 'uppercase',
  padding: 7
};

const b2cSVG = () =>
  <span style={b2cStyle}>
    b2c
  </span>;

export default b2cSVG;



// WEBPACK FOOTER //
// ./src/svg/b2cSVG.js